import config from "../../config";
import axiosInstance from "../axiosInstance";

const typeOfUseDummyData = [
	{
		id: 1,
		name: "Particular",
	},
	{
		id: 2,
		name: "Otros tipo de uso no particulares",
	}
];

// Año actual para determinar si un año es "reciente" (0km) o usado
const CURRENT_YEAR = new Date().getFullYear();

/**
 * Determina si un año corresponde a un vehículo 0km (año actual o siguiente)
 * Los vehículos de años recientes no tienen precios usados en InfoAuto,
 * por lo que se debe filtrar por precio de lista (0km) en vez de precios usados.
 */
const isRecentYear = (year) => year >= CURRENT_YEAR;

/**
 * Construye los parámetros de filtro por año según si es 0km o usado.
 * - Años recientes (>= año actual): usa list_price=true (precio 0km)
 * - Años anteriores: usa price_at=year (precio usado en ese año)
 */
const buildYearFilterParams = (year) => {
	if (isRecentYear(year)) {
		return { list_price: true };
	}
	return { price_at: year };
};

// Función para obtener marcas por año (carga inicial)
const get_car_brands_by_year = async (fetchWithAuth, year, pageSize = 100) => {
	const params = new URLSearchParams({
		...buildYearFilterParams(year),
		page_size: pageSize
	});
	
	return await fetchWithAuth(`${config.infoauto.proxyUrl}/brands/?${params}`);
};

// Función para buscar marcas por año y texto
const get_car_brands_search = async (fetchWithAuth, year, searchTerm, pageSize = 100) => {
	const params = new URLSearchParams({
		...buildYearFilterParams(year),
		query_string: searchTerm,
		query_mode: "matching",
		page_size: pageSize
	});
	
	return await fetchWithAuth(`${config.infoauto.proxyUrl}/brands/?${params}`);
};

// Función legacy para compatibilidad (ahora usa proxy)
const get_car_brands = async (fetchWithAuth) => {
	return await fetchWithAuth(`${config.infoauto.proxyUrl}/brands/`);
};

// Función para obtener modelos por marca, filtrados por año
const get_car_brand_models = async (fetchWithAuth, brandId, year, pageSize = 100) => {
	const yearFilter = year ? buildYearFilterParams(year) : {};
	const params = new URLSearchParams({
		...yearFilter,
		page_size: pageSize
	});
	
	return await fetchWithAuth(`${config.infoauto.proxyUrl}/brands/${brandId}/models/?${params}`);
};

// Función para buscar modelos por marca y texto, filtrados por año
const get_car_brand_models_search = async (fetchWithAuth, brandId, searchTerm, year, pageSize = 100) => {
	const yearFilter = year ? buildYearFilterParams(year) : {};
	const params = new URLSearchParams({
		...yearFilter,
		query_string: searchTerm,
		query_mode: "matching",
		page_size: pageSize
	});
	
	return await fetchWithAuth(`${config.infoauto.proxyUrl}/brands/${brandId}/models/?${params}`);
};

// Función para obtener información específica de un modelo (incluyendo CODIA)
const get_car_model_info = async (fetchWithAuth, codia) => {
	return await fetchWithAuth(`${config.infoauto.proxyUrl}/models/${codia}`);
};

// Función para obtener fotos de un modelo por CODIA
const get_car_model_photos = async (fetchWithAuth, codia) => {
	try {
		console.log(`Fetching photos for CODIA ${codia} from: ${config.infoauto.proxyUrl}/models/${codia}/photos/`);
		const response = await fetchWithAuth(`${config.infoauto.proxyUrl}/models/${codia}/photos/`);
		console.log(`Photos API response for CODIA ${codia}:`, response);
		return response || [];
	} catch (error) {
		console.warn(`No photos found for CODIA ${codia}:`, error);
		console.warn(`Error details:`, error.response?.data || error.message);
		return [];
	}
};

// Función para obtener datos del vehículo por patente usando la API cardata
const get_car_data_by_patent = async (patent) => {
	try {
		const response = await axiosInstance.get(`${config.baseUrl}/cardata/${patent}`);
		return response.data;
	} catch (error) {
		// Re-lanzar el error para que pueda ser manejado por el componente
		throw error;
	}
};

const get_car_type_of_use = () => {
	return typeOfUseDummyData;
};

export {
	get_car_data_by_patent,
	get_car_brands,
	get_car_brands_by_year,
	get_car_brands_search,
	get_car_brand_models,
	get_car_brand_models_search,
	get_car_model_info,
	get_car_model_photos,
	get_car_type_of_use,
	isRecentYear,
};
